import React, { useCallback, useState } from 'react';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import styled from 'styled-components';
import { color } from '@nuvolo/nuux-theme/utils';
import ActionInput from '../ActionInput';

const StyledActionInput = styled(ActionInput)`
  background-color: ${color('custom', 'formInputBackground')} !important;
  .dx-button {
    background-color: ${color('custom', 'formInputBackground')} !important;
  }
  //customize the next sibling of this component - in this case its the search button
  & + .dx-widget.dx-button.dx-button-mode-contained.dx-button-normal {
    background-color: ${color('custom', 'inputIconBackground')} !important;
    border: 1px solid ${color('custom', 'formInputBorder')} !important;
  }
`;

export interface SearchBoxProps {
  onSearch: (value: string) => void;
  defaultValue?: string;
}

const SearchBox: React.FC<SearchBoxProps> = ({ onSearch, defaultValue }) => {
  const [search, setSearch] = useState(defaultValue ?? '');

  const applySearch = useCallback(() => {
    onSearch(search);
  }, [onSearch, search]);

  return (
    <>
      <NuvoBox flex={1}>
        <StyledActionInput
          value={search}
          onValueChange={setSearch}
          onAction={applySearch}
          icon="search"
          showClearButton
          className="search-input-list"
        />
      </NuvoBox>
    </>
  );
};

export default React.memo(SearchBox);
